import { forRails } from 'components/for-rails'
import { OrgSkillsPage } from 'pages/org-skills-page'
import { OrgSkillGapsPage } from 'pages/org-skill-gaps-page'
import { OrgPersonalSkillsPage } from 'pages/org-personal-skills-page'
import { UserPersonalSkillsPage } from 'pages/user-personal-skills-page'
import { registerComponents } from '../src/utils/react/registry'
import { SkillEditableByLabel } from 'components/skill-editable-by-label'
import { SkillVariantDialog } from 'components/skill-variant-dialog'

registerComponents({
  OrgSkillsPage: forRails(OrgSkillsPage),
  OrgSkillGapsPage: forRails(OrgSkillGapsPage),
  OrgPersonalSkillsPage: forRails(OrgPersonalSkillsPage),
  UserPersonalSkillsPage: forRails(UserPersonalSkillsPage),
  SkillEditableByLabel: forRails(SkillEditableByLabel),
  SkillVariantDialog: forRails(SkillVariantDialog),
})
